import type { ChoirFunction, DocumentType, Member, MemberType, Voice } from '../types'

type Raw = [
  ime: string,
  priimek: string,
  type: MemberType,
  voice: Voice,
  functions: ChoirFunction[],
  prisoten: number,
  pricakovan: number,
  clanOd: string,
]

const raw: Raw[] = [
  ['Krištof', 'Strnad', 'aktivni', 'brez', ['dirigent'], 24, 24, '2009-09-01'],
  ['Dejan', 'Jerončič', 'aktivni', 'brez', ['korepetitor'], 21, 24, '2014-10-01'],
  ['Judita', 'Volčanšek', 'aktivni', 'sopran1', ['pevec', 'tajnik'], 22, 24, '2012-09-15'],
  ['Timotej', 'Siter', 'aktivni', 'bas1', ['pevec', 'predsednik'], 17, 23, '2010-09-01'],
  ['Barbara', 'Ganzitti Siter', 'aktivni', 'alt1', ['pevec', 'blagajnik'], 19, 24, '2011-02-01'],
  ['Alenka', 'Črnelič', 'aktivni', 'sopran2', ['pevec', 'reditelj'], 14, 22, '2016-09-01'],
  ['Jurij', 'Žnideršič', 'aktivni', 'tenor1', ['pevec', 'umetniska'], 20, 23, '2013-09-01'],
  ['Jelka', 'Žnideršič', 'aktivni', 'alt2', ['pevec', 'disciplinska'], 5, 6, '2026-09-08'],
  ['Veronika', 'Strnad', 'gostujoci', 'sopran2', ['pevec', 'umetniska'], 6, 9, '2024-11-01'],
  ['Simona', 'Rožman Strnad', 'neaktivni', 'alt1', ['pevec', 'umetniska'], 0, 0, '2008-09-01'],

  ['Maja', 'Kovačič', 'aktivni', 'sopran1', ['pevec'], 23, 24, '2015-09-01'],
  ['Nina', 'Zorko', 'aktivni', 'sopran1', ['pevec'], 21, 24, '2017-09-01'],
  ['Katja', 'Ferlin', 'aktivni', 'sopran1', ['pevec', 'umetniska'], 20, 24, '2013-01-10'],
  ['Petra', 'Vidmar', 'aktivni', 'sopran1', ['pevec'], 16, 23, '2019-09-01'],
  ['Sara', 'Bizjak', 'aktivni', 'sopran1', ['pevec'], 22, 24, '2021-09-01'],
  ['Tina', 'Molan', 'aktivni', 'sopran2', ['pevec'], 18, 24, '2018-09-01'],
  ['Lucija', 'Kranjc', 'aktivni', 'sopran2', ['pevec'], 23, 24, '2016-02-01'],
  ['Eva', 'Pirc', 'aktivni', 'sopran2', ['pevec'], 15, 22, '2020-09-01'],
  ['Mateja', 'Zupan', 'aktivni', 'sopran2', ['pevec'], 21, 23, '2012-09-01'],
  ['Anja', 'Košir', 'aktivni', 'alt1', ['pevec'], 24, 24, '2014-09-01'],
  ['Marija', 'Bogovič', 'aktivni', 'alt1', ['pevec'], 19, 24, '2009-09-01'],
  ['Špela', 'Rajh', 'aktivni', 'alt1', ['pevec', 'reditelj'], 20, 23, '2018-09-01'],
  ['Nataša', 'Levak', 'aktivni', 'alt1', ['pevec'], 13, 21, '2022-09-01'],
  ['Irena', 'Kržan', 'aktivni', 'alt2', ['pevec'], 22, 24, '2011-09-01'],
  ['Vesna', 'Planinc', 'aktivni', 'alt2', ['pevec'], 18, 24, '2015-09-01'],
  ['Metka', 'Sotlar', 'aktivni', 'alt2', ['pevec'], 21, 24, '2010-09-01'],
  ['Darja', 'Kokot', 'aktivni', 'alt2', ['pevec'], 16, 24, '2019-09-01'],
  ['Ana', 'Radanovič', 'gostujoci', 'alt2', ['pevec'], 4, 7, '2025-10-01'],
  ['Blaž', 'Cvetkovič', 'aktivni', 'tenor1', ['pevec'], 20, 24, '2016-09-01'],
  ['Matic', 'Deržič', 'aktivni', 'tenor1', ['pevec'], 15, 22, '2021-09-01'],
  ['Rok', 'Šoln', 'aktivni', 'tenor1', ['pevec', 'organizator'], 22, 24, '2013-09-01'],
  ['Aleš', 'Preskar', 'aktivni', 'tenor2', ['pevec'], 17, 24, '2017-09-01'],
  ['Gregor', 'Hribar', 'aktivni', 'tenor2', ['pevec', 'disciplinska'], 21, 24, '2012-09-01'],
  ['Miha', 'Bregar', 'aktivni', 'tenor2', ['pevec'], 12, 20, '2023-09-01'],
  ['Vid', 'Ogorevc', 'aktivni', 'tenor2', ['pevec'], 19, 23, '2020-09-01'],
  ['Janez', 'Kuhar', 'aktivni', 'bas1', ['pevec'], 23, 24, '2008-09-01'],
  ['Marko', 'Kelhar', 'aktivni', 'bas1', ['pevec'], 18, 24, '2015-09-01'],
  ['Bojan', 'Zorc', 'aktivni', 'bas1', ['pevec'], 20, 24, '2011-09-01'],
  ['Uroš', 'Tomše', 'aktivni', 'bas2', ['pevec'], 16, 23, '2018-09-01'],
  ['Damjan', 'Stopar', 'aktivni', 'bas2', ['pevec', 'arhivar'], 22, 24, '2010-09-01'],
  ['Andrej', 'Mlakar', 'aktivni', 'bas2', ['pevec'], 14, 22, '2019-09-01'],
  ['Primož', 'Račič', 'aktivni', 'bas2', ['pevec'], 21, 24, '2014-09-01'],
  ['Tadej', 'Zakšek', 'gostujoci', 'bas1', ['pevec'], 5, 8, '2025-09-01'],
  ['Nika', 'Jazbec', 'neaktivni', 'sopran1', ['pevec'], 0, 0, '2017-09-01'],
  ['Boštjan', 'Urek', 'nekdanji', 'tenor1', ['pevec'], 0, 0, '2007-09-01'],
  ['Ivan', 'Uršič', 'castni', 'bas2', ['pevec', 'umetniska'], 0, 0, '1994-09-01'],
]

const ulice = [
  'Cesta prvih borcev',
  'Trg izgnancev',
  'Bizeljska cesta',
  'Černelčeva cesta',
  'Trdinova ulica',
  'Šolska ulica',
  'Maistrova ulica',
  'Prešernova cesta',
]

const kraji: [string, string][] = [
  ['8250', 'Brežice'],
  ['8259', 'Bizeljsko'],
  ['8280', 'Brestanica'],
  ['8270', 'Krško'],
  ['8261', 'Jesenice na Dolenjskem'],
]

/** Člani z namerno nepopolnimi osebnimi podatki — za prikaz kontrole pred gostovanjem. */
const vrzeli: Record<string, ('datumRojstva' | 'dokumentTip' | 'dokumentStevilka' | 'prehrana' | 'naslov')[]> =
  {
    m04: ['dokumentStevilka'],
    m05: ['datumRojstva', 'dokumentTip', 'dokumentStevilka'],
    m14: ['dokumentStevilka'],
    m28: ['datumRojstva', 'dokumentStevilka'],
    m34: ['dokumentStevilka'],
  }

function slug(s: string): string {
  return s
    .toLowerCase()
    .replace(/č/g, 'c')
    .replace(/š/g, 's')
    .replace(/ž/g, 'z')
    .replace(/[^a-z]/g, '')
}

export const members: Member[] = raw.map(
  ([ime, priimek, type, voice, functions, prisoten, pricakovan, clanOd], i) => {
    const id = `m${String(i + 1).padStart(2, '0')}`
    const [posta, kraj] = kraji[i % kraji.length]
    const leto = 1958 + ((i * 7) % 44)
    const mesec = ((i * 5) % 12) + 1
    const dan = ((i * 11) % 27) + 1
    const dokTip: DocumentType = i % 3 === 0 ? 'potni_list' : 'osebna'
    const manjka = vrzeli[id] ?? []

    const clan: Member = {
      id,
      ime,
      priimek,
      type,
      voice,
      functions,
      email: `${slug(ime)}.${slug(priimek.split(' ')[0])}@mepz-viva.si`,
      telefon: `031 ${String(200 + i * 7).slice(0, 3)} ${String(400 + i * 13).slice(0, 3)}`,
      clanOd,
      naslov: `${ulice[i % ulice.length]} ${((i * 3) % 40) + 1}`,
      postnaStevilka: posta,
      posta: kraj,
      datumRojstva: `${leto}-${String(mesec).padStart(2, '0')}-${String(dan).padStart(2, '0')}`,
      dokumentTip: dokTip,
      dokumentStevilka: `${dokTip === 'potni_list' ? 'PB' : 'OI'}${String(1000000 + i * 7919).slice(0, 7)}`,
      prehrana:
        i % 9 === 0
          ? 'Vegetarijanska prehrana'
          : i % 13 === 0
            ? 'Brez glutena'
            : undefined,
      prisoten,
      pricakovan,
      opomba:
        type === 'neaktivni'
          ? 'Začasno neaktivna zaradi družinskih obveznosti. Vrnitev predvidoma jeseni 2027.'
          : type === 'castni'
            ? 'Častni član zbora, soustanovitelj. Vabljen na vse slovesne dogodke.'
            : undefined,
    }

    manjka.forEach((polje) => {
      delete clan[polje]
    })

    return clan
  },
)

export const byId = (id: string): Member | undefined => members.find((m) => m.id === id)

/** Demo profiles used on the login screen. */
export const DEMO_CLAN = 'm03' // Judita Volčanšek
export const DEMO_GOST = 'm09' // Veronika Strnad
export const DEMO_ADMIN = 'm01' // Krištof Strnad
